import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'

import Analytics from './components/Analytics/Analytics';
import Home from './components/Home/Home';
import Landing from './components/Landing/Landing';
import Onboard from './components/Onboard/Onboard';
import RequestPassword from './components/RequestPassword/RequestPassword'

import './Main.css';

class Main extends Component {
    render() {
        return (
            <div className="Main">
                <Switch>
                    <Route exact path='/' component={Landing}/>
                    <Route exact path='/home' component={Home}/>
                    <Route path='/onboard' component={Onboard}/>
                    <Route path='/analytics' component={Analytics}/>
                    <Route path='/request' component={RequestPassword}/>
                </Switch>
            </div>
        );
    }
};

export default Main;



// WEBPACK FOOTER //
// ./src/components/App/components/Main/Main.js